import nacl from 'tweetnacl'
import naclUtil from 'tweetnacl-util'
import { DEFAULT_TIMEZONE_NAME } from '@/libs/constants'

export function isString (value) {
  return typeof value === 'string'
}

export function encrypt (data, key) {
  function padEnd (string, targetLength, padString) {
    targetLength = targetLength >> 0
    padString = String((typeof padString !== 'undefined' ? padString : ' '))
    if (string.length > targetLength) {
      return string.slice(0, 32)
    } else {
      targetLength = targetLength - string.length
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length)
      }
      return string + padString.slice(0, targetLength)
    }
  }

  function textEncode (str) {
    if (window.TextEncoder) {
      return new TextEncoder('utf-8').encode(str)
    }
    let utf8 = unescape(encodeURIComponent(str))
    let result = new Uint8Array(utf8.length)
    for (let i = 0; i < utf8.length; i++) {
      result[i] = utf8.charCodeAt(i)
    }
    return result
  }

  const encodeBase64 = naclUtil.encodeBase64
  const nonce = nacl.randomBytes(24)
  const secretKey = textEncode(padEnd(key, 32, '0'))
  const secretData = textEncode(data)
  const encrypted = nacl.secretbox(secretData, nonce, secretKey)
  return `${encodeBase64(nonce)}:${encodeBase64(encrypted)}`
}

export const browserInfo = getBrowserInfo()

function getBrowserInfo () {
  const uaContains = (str) => window.navigator.userAgent.indexOf(str) !== -1
  let name = null
  let platform = null

  if (uaContains('Windows')) {
    platform = 'window'

    if (uaContains('MSIE') || uaContains('Trident/')) {
      name = 'ie'
    }
  }

  if (uaContains('Firefox')) {
    name = 'firefox'
  }

  if (uaContains('Chrome')) {
    name = 'chrome'
  }

  if (uaContains('Safari') && !uaContains('Chrome')) {
    name = 'safari'
  }

  if (uaContains('Edge')) {
    name = 'edge'
  }

  return {
    name,
    platform
  }
}

export function thousand (value, fixed = 0) {
  value = Number(value)
  return value.toLocaleString('en-US', { minimumFractionDigits: fixed, maximumFractionDigits: fixed })
}

export function getChartYAxisMaxValue (value) {
  let max = ''
  const length = ('' + value).length
  for (let i = 0, iLen = length; i < iLen; i++) {
    max += '9'
  }
  return Number(max) + 1
}

export function getChartSplitValue (value) {
  let max = ''
  const length = ('' + value).length
  for (let i = 0, iLen = length; i < iLen; i++) {
    if (i === 0) {
      max += '1'
    } else {
      max += '0'
    }
  }
  return Number(max)
}

export function getOffset (timezoneName = DEFAULT_TIMEZONE_NAME) {
  const date = new Date()
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezoneName }))
  let offset = (tzDate.getTime() - utcDate.getTime())
  let offset2 = offset / 60000
  let o1 = Math.abs(offset2)
  const offsetValue1 = (offset2 >= 0 ? '+' : '-') + ('00' + Math.floor(o1 / 60)).slice(-2) + ':' + ('00' + (o1 % 60)).slice(-2)
  return offsetValue1
}
